import { FETCH_SET_SUCCESS, FETCH_SET_FAILED, CLEAR_SET } from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  results: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SET_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
        results: action.results,
      };
    case FETCH_SET_FAILED:
      return { ...state, status: 'error', error: action.error };
    case CLEAR_SET:
      return { ...initialState, status: 'clear' };
    default:
      return state;
  }
};
